// We need a separate themes entrypoint not to export it together with fonts and components
export { defaultActivityThemeStyles } from './implementations/core/themes/defaultActivityThemeStyles';
